import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import CommonUiIcon from 'webapp/components/common/ui-icon';

interface OnboardingGuidedTourStepsComponentInterface {
	Element: HTMLDivElement;
	Args: {
		allFulfilled?: boolean;
	};
}

export default class OnboardingGuidedTourStepsComponent extends Component<OnboardingGuidedTourStepsComponentInterface> {
	@service('flow/tour/onboarding')
	declare flowTourOnboardingService: Service.Flow.Tour.Onboarding;

	get steps() {
		const { stepId, tourStepId, activeTour } = this.flowTourOnboardingService;

		return this.flowTourOnboardingService.steps.map((step, index) => {
			const stepClasses = ['step', `step-${step.id}`];
			let isFulfilled = false;

			if (stepId === index) {
				stepClasses.push('step--active');
			}

			if (
				stepId > index ||
				(stepId === index &&
					tourStepId === (activeTour && activeTour.stepData?.length - 1)) ||
				this.args.allFulfilled
			) {
				stepClasses.push('step--fulfilled');
				isFulfilled = true;
			}

			return {
				id: step.id,
				title: step.title,
				icon: step.icon,
				extraClasses: stepClasses.join(' '),
				isFulfilled,
			};
		});
	}

	<template>
		<div class="onboarding-guided-tour-steps">
			{{#each this.steps as |step|}}
				<div class={{step.extraClasses}}>
					<div class="step__icon">
						<CommonUiIcon @name={{step.icon}} @size="xl" />
						{{#if step.isFulfilled}}
							<CommonUiIcon @name="Check" @size="xs" class="fulfilled-check" />
						{{/if}}
					</div>
					<div class="step__subtitle">Step {{step.id}}</div>
					<div class="step__title">{{step.title}}</div>
				</div>
			{{/each}}
		</div>
	</template>
}
